export default {
  book: 'Book',
  book1: 'Details & Book',
  seats_left: '{count} seats left',
  detail: 'Details',
  reviews: 'Reviews',
  notice: 'Notice',
  discount: 'Discount',
  promotion: 'Promotion',
  from: 'From',
  important: 'Important',
}
